var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dropzone',{ref:"dropzone",attrs:{"options":_vm.dropzoneOptions,"id":_vm._uid+'vwdropzone'},on:{"vdropzone-success":_vm.fileUploaded,"vdropzone-file-added":_vm.fileAdded}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-557b8ffc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/editor/modules/image.vue
// module id = null
// module chunks = 